import React from 'react';

export function Seo({
  title,
  description,
  children
}: { title?: string; description?: string; children?: React.ReactNode }) {
  return (
    <>
      {title && (
        <title>{`${title} | myTalquin Member Portal`}</title>
      )}
      <meta name="description" content={description} />
      {children}
    </>
  );
}
